module.exports = __webpack_public_path__ + "img/9772850_orig.5ff56f1d.png";